import * as interpolationService from '@/services/interpolationService';

export function interpolate(
    string: string,
    placeholders?: { [placeholderName: string]: unknown },
): string {
    return interpolationService.interpolate(string, placeholders);
}
